/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { Connection } from './Connection';
import {
    ConnectionFromJSON,
    ConnectionFromJSONTyped,
    ConnectionToJSON,
    ConnectionToJSONTyped,
} from './Connection';

/**
 * 
 * @export
 * @interface Connections
 */
export interface Connections  {
    /**
     * 
     * @type {Array<Connection>}
     * @memberof Connections
     */
    connectionList?: Array<Connection>;
}

/**
 * Check if a given object implements the Connections interface.
 */
export function instanceOfConnections(value: object): value is Connections {
    return true;
}

export function ConnectionsFromJSON(json: any): Connections {
    return ConnectionsFromJSONTyped(json, false);
}

export function ConnectionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Connections {
    if (json == null) {
        return json;
    }
    return {
        
              'connectionList': json['connectionList'] == null ? undefined : ((json['connectionList'] as Array<any>).map(ConnectionFromJSON)),
    };
}

export function ConnectionsToJSON(json: any): Connections {
    return ConnectionsToJSONTyped(json, false);
}

export function ConnectionsToJSONTyped(value?: Connections | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'connectionList': value['connectionList'] == null? value['connectionList']: (value['connectionList'] as Array<any>).map(ConnectionToJSON),
    };
}


